export class Search {
	static readonly type = '[lawFirmSearch] search';
	constructor(public searchTerm) {}
}
